package navigation.home.address

import org.koin.core.qualifier.named
import org.koin.dsl.module

val AddressUiModule
    get() =
        module {
            factory {
                AddressScreenModel(
                    loadingManager = get(),
                    addressRepository = get(),
                )
            }

            fun addressScreenModel(name: String) =
                factory(named(name)) {
                    AddressScreenModel(
                        loadingManager = get(),
                        addressRepository = get(),
                    )
                }

            addressScreenModel("organization")
            addressScreenModel("contact")
        }